import React from "react";

const Select = ({ name, label, options, error, ...rest }) => {
  return (
    <React.Fragment>
      <select name={name} id={name} {...rest} className="form-control">
        <option value="" />
        {options.map((option, idx) => {
          // Support both string options and {label, value} objects
          const isObject = typeof option === 'object' && option !== null;
          const value = isObject ? option.value : option;
          const displayLabel = isObject ? option.label : option;

          return (
            <option key={idx} value={value}>
              {displayLabel}
            </option>
          );
        })}
      </select>
      {error && <div className="alert alert-danger">{error}</div>}
    </React.Fragment>
  );
};

export default Select;
